// extracted by mini-css-extract-plugin
export default {"timer":"c8FXm","waiting":"eTX9d","iconReset":"qxCIn","ResendCodeTimerRotation":"vDhb6","action":"_lOdF"};